import { get } from '@rails/request.js';

import Dropdown from './components/dropdown_controller';
import Form from './components/form_controller';

export default class extends Form {
  static targets = ['submit', 'featuredDesignPreview'];

  dropdowns = {
    category: null,
    product: null,
    position: null,
  };

  dropdownReady(e) {
    this.dropdowns[e.detail.dropdown.id] = e.detail.dropdown;

    if (e.detail.dropdown.id === 'product' && this.dropdowns.product.getSelection()?.data?.img) {
      this.updatePreviewImage(this.dropdowns.product.getSelection().data.img);
    }

    if (Object.values(this.dropdowns).every((d) => { return d !== null; })) {
      this.validate();
    }

    // if (e.detail.dropdown.id === 'design' && this.dropdowns.design.getSelection()) {
    //   this.updatePreviewImage(this.dropdowns.design.getSelection().data?.img);
    // }
  }

  dropdownUpdate(e) {
    const dropdown = e.detail.dropdown;
    if (dropdown.id === 'category') this.categorySelected(dropdown);
    else if (dropdown.id === 'product') this.designSelected(dropdown);
    this.validate();
  }

  /**
   * Update designs dropdown based on selected category
   * @param {Dropdown} dropdown Category dropdown controller
   */
  categorySelected(dropdown) {
    const selection = dropdown.getSelection();
    const streamPath = dropdown.streamValue; // Get from dropdown, not this

    // No selection. Skip everything else
    if (!selection) return;

    // Throw error when dependent element cant be found
    if (!dropdown.dependentElement) throw Error('Dependent element missing for dropdown');

    // Initializing with value, enable designs and prevent refresh
    // if (dropdown.initializing) {
    //   dropdown.updateDependent(Dropdown.events.disable);
    //   return;
    // }

    dropdown.updateDependent(Dropdown.events.enable);

    get(`${streamPath}?category_id=${selection.value}`, {
      contentType: 'application/json',
      responseKind: 'turbo-stream',
    }).then(() => {
      console.log('Products loaded, reloading dependent dropdown');
      dropdown.updateDependent(Dropdown.events.reload);
    }).catch((error) => {
      console.error('Failed to load products:', error);
    });
  }

  /**
   * Update designs dropdown based on selected category
   * @param {Dropdown} dropdown Category dropdown controller
   */
  designSelected(dropdown) {
    const selection = dropdown.getSelection();

    // Throw error when dependent element cant be found
    if (!dropdown.dependentElement) throw Error('Dependent element missing for dropdown');
    if (!this.hasFeaturedDesignPreviewTarget) throw Error('Design Preview element missing');

    // No selection, set preview to blank state
    if (!selection) {
      this.clearPreviewImage();
      dropdown.updateDependent(Dropdown.events.disableEvent, {});
      return;
    }

    // Selection made, update preview
    dropdown.updateDependent(Dropdown.events.enable);
    // Update preview
    if (selection.data?.img) {
      this.updatePreviewImage(selection.data.img);
    } else {
      this.clearPreviewImage();
    }
  }

  /**
   * Update the src of the design preview
   * @param {string} imgSrc Image source
   */
  updatePreviewImage(imgSrc) {
    if (imgSrc) {
      this.featuredDesignPreviewTarget.parentElement.classList.remove('blank');
      this.featuredDesignPreviewTarget.setAttribute('src', imgSrc);
    }
  }

  clearPreviewImage() {
    this.featuredDesignPreviewTarget.setAttribute('src', '');
    this.featuredDesignPreviewTarget.parentElement.classList.add('blank');
  }

  validate() {
    let valid = true;
    const form = this.element || this.element.closest('form');
    const requiredFields = form.querySelectorAll('[required]');

    // check all required dropdowns
    requiredFields.forEach((field) => {
      if (field.id && this.dropdowns[field.id]) {
        if (!this.dropdowns[field.id].getSelection()) {
          valid = false;
        }
      } else if (!field.value) {
        valid = false;
      }
    });

    if (!valid) {
      this.dropdowns.position?.disable();
      this.submitTarget.setAttribute('disabled', true);
    } else {
      this.dropdowns.position?.enable();
      this.submitTarget.removeAttribute('disabled');
    }
  }
}
